export const Logo = () => {
  return (
    <img width="240" height="240" src="logo.png" />
  );
};
